import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEllipsisV, faPhone, faSync } from '@fortawesome/free-solid-svg-icons';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { PaceStatusStepButton, PaceStatusStepEntry } from './pace-status-step-button.interface';

/**
 * Presentational split button for stepping a notification through its statuses: the next status on
 * the main half, the remaining ones behind the dropdown.
 *
 * Everything it renders comes from {@link PaceStatusStepButton}; the only thing it reports back is
 * which action the user picked.
 */
@Component({
    selector: 'pace-status-step-button',
    imports: [FontAwesomeModule, BsDropdownModule],
    templateUrl: './pace-status-step-button.component.html',
    styleUrls: ['./pace-status-step-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaceStatusStepButtonComponent {
    public readonly stepButton = input.required<PaceStatusStepButton>();

    public readonly actionSelect = output<PaceStatusStepEntry>();

    public readonly faEllipsisV = faEllipsisV;
    public readonly faPhone = faPhone;
    public readonly faLoading = faSync;
}
